// Zentrale Konfigurationsdatei für den Reit- und Fahrverein Holle-Wüsting e.V.
// Diese Datei enthält alle konfigurierbaren Werte, die sich ändern könnten

export const siteConfig = {
  // Mitgliedschaftsbeiträge
  membership: {
    active: {
      children: 120, // Kinder bis 18 Jahre (EUR/Jahr)
      adults: 180, // Erwachsene (EUR/Jahr)
    },
    supporter: 60, // Fördermitgliedschaft (EUR/Jahr)
    boarding: 350, // Pferdeeinsteller (EUR/Monat)
    // DEPRECATED (Stand 2026-05-29): Diese Werte werden im Code nicht mehr
    // gelesen. Die verbindliche Auskunft zu Arbeitsstunden steht im FAQ auf
    // der Mitgliedschaft-Seite (Membership.jsx). Aktuelle Regelung:
    // - ab 12. Lebensjahr: 10 Stunden / Jahr
    // - ab 18. Lebensjahr: 15 Stunden / Jahr
    // - Geld-Abgeltung moeglich (Saetze vom Vorstand festgelegt).
    // Block bleibt fuer eventuell verbleibende externe Konsumenten der
    // siteConfig-Struktur erhalten - bei Bedarf altersgestaffelt nachpflegen.
    workHours: {
      required: 12, // deprecated
      replacement: 15, // deprecated
    },
  },

  // Reitunterricht-Preise
  ridingLessons: {
    children: {
      price: 0, // Preis auf Anfrage
      duration: 45, // Minuten
      maxParticipants: 6,
      minAge: 6,
    },
    beginners: {
      price: 25, // EUR
      duration: 60, // Minuten
      maxParticipants: 6,
      minAge: 12,
    },
    advanced: {
      price: 30, // EUR
      duration: 60, // Minuten
      maxParticipants: 4,
    },
  },

  // Kontaktinformationen
  contact: {
    email: 'info@reitverein-hollewuesting.de',
    phone: '04484 9581745',
    phoneHours: 'Mo-Fr 9:00 - 17:00 Uhr',
    address: {
      street: 'Oberhauser Kirchweg 4',
      zip: '27798',
      city: 'Hude',
    },
  },

  // Social Media Links
  socialMedia: {
    facebook: 'https://www.facebook.com/share/g/1C2s8sYo3p/',
    instagram: 'https://www.instagram.com/reitverein.hollewuesting',
    tiktok: 'https://www.tiktok.com/@reitverein.hollewuesting',
  },

  // Google Maps Koordinaten
  googleMaps: {
    lat: 53.0315,
    lng: 8.5315,
    embedUrl:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2391.5!2d8.5315!3d53.0315!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTPCsDAyJzAwLjAiTiA4wrAzMScwMC4wIkU!5e0!3m2!1sde!2sde!4v1234567890',
  },

  // Vereinsstammdaten (Defaults – werden vom Backend überschrieben sobald Daten gepflegt sind)
  clubInfo: {
    name: 'Reit- und Fahrverein Holle-Wüsting e.V.',
    foundingYear: 1925,
  },

  // Vereinsstatistiken (Defaults)
  stats: {
    members: 300,
    ridingLessonsPerWeek: 19,
    yearsOfTradition: 100,
    areaHectares: 3,
  },

  // Anlagen-Informationen
  facilities: {
    ridingHall: {
      dimensions: '20 x 40',
      surface: 'Sandgemisch',
    },
    dressageArena: {
      dimensions: '20 x 60',
      surface: 'Sand-Vlies-Gemisch',
    },
    jumpingArena: {
      dimensions: '20 x 40',
      surface: 'Sand-Vlies-Gemisch',
    },
    lungeCircle: {
      diameter: 18,
      surface: 'Sand',
    },
    stables: {
      boxes: 40,
    },
  },

  // eRecht24 Integration Placeholders
  legal: {
    erecht24: {
      impressumPlaceholder: true,
      datenschutzPlaceholder: true,
      cookiePlaceholder: true,
    },
  },

  // Friendly Captcha (EU-Anbieter, DSGVO-konform OHNE Cookie-Banner)
  // Site-Key ist oeffentlich. Der GEHEIME API-Key liegt im Backend
  // (.env -> FRIENDLY_CAPTCHA_API_KEY).
  // Schluesselpaar anlegen: https://app.friendlycaptcha.com/account
  // Leerer siteKey -> Captcha-Widget wird nicht eingebunden (Dev-Modus).
  captcha: {
    siteKey: process.env.REACT_APP_FRIENDLY_CAPTCHA_SITEKEY || '',
  },
};

export default siteConfig;
